
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Agricultural-Finance-Credit-Insurance",
      function () {
        return require("private-next-pages/Agricultural-Finance-Credit-Insurance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Agricultural-Finance-Credit-Insurance"])
      });
    }
  